module.exports = __webpack_public_path__ + "components/PaperTile/wezelkrajowy.png?ed6f2e37";


//////////////////
// WEBPACK FOOTER
// ./components/PaperTile/wezelkrajowy.png
// module id = 1089
// module chunks = 0